"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EventBusSettings = void 0;
const messageParams = {
    correlationId: ':correlation_id',
    endEventId: ':end_event_id',
    externalTaskId: ':external_task_id',
    flowNodeInstanceId: ':flow_node_instance_id',
    messageReference: ':message_ref',
    processInstanceId: ':process_instance_id',
    processModelId: ':process_model_id',
    userTaskId: ':user_task_id',
    manualTaskId: ':manual_task_id',
    emptyActivityId: ':empty_activity_id',
    signalReference: ':signal_ref',
    topicName: ':topicName',
};
const messagePaths = {
    activityReached: 'activity_reached',
    activityFinished: 'activity_finished',
    boundaryEventTriggered: 'boundary_event_triggered',
    cronjobCreated: 'cronjob_created',
    cronjobExecuted: 'cronjob_executed',
    cronjobStopped: 'cronjob_stopped',
    cronjobUpdated: 'cronjob_updated',
    cronjobRemoved: 'cronjob_removed',
    emptyActivityReached: 'empty_activity_reached',
    emptyActivityFinished: 'empty_activity_finished',
    externalTaskCreated: 'external_task_created',
    externalTaskExpired: `external_task_expired/${messageParams.externalTaskId}`,
    externalTaskFinished: `external_task_finished/${messageParams.externalTaskId}`,
    externalTaskLocked: 'external_task_locked',
    externalTaskUnlocked: 'external_task_unlocked',
    intermediateThrowEventTriggered: 'intermediate_throw_event_triggered',
    intermediateCatchEventReached: 'intermediate_catch_event_reached',
    intermediateCatchEventFinished: 'intermediate_catch_event_finished',
    manualTaskReached: 'manual_task_reached',
    manualTaskFinished: 'manual_task_finished',
    processDeployed: 'process_deployed',
    processUndeployed: 'process_undeployed',
    processInstanceDeleted: 'process_instance_deleted',
    processExecutableChanged: 'process_executable_changed',
    userTaskReached: 'user_task_reached',
    userTaskFinished: 'user_task_finished',
    userTaskReserved: 'user_task_reserved',
    userTaskReservationCanceled: 'user_task_reservation_canceled',
    messageOnProcessInstanceTriggered: `/engine/process/${messageParams.processInstanceId}/message/${messageParams.messageReference}`,
    messageTriggered: 'message_triggered',
    signalOnProcessInstanceTriggered: `/engine/process/${messageParams.processInstanceId}/signal/${messageParams.signalReference}`,
    signalTriggered: 'signal_triggered',
    tokenPayloadChange: `token_payload_change_${messageParams.flowNodeInstanceId}`,
    tokenPayloadChangeFinished: `token_payload_change_finished_${messageParams.flowNodeInstanceId}`,
    processStarting: 'OnProcessStarting',
    processStarted: 'OnProcessStarted',
    processResumed: 'OnProcessResumed',
    processEnded: 'OnProcessFinished',
    processError: 'OnProcessError',
    processTerminated: 'OnProcessTerminated',
    flowNodeEntered: 'OnFlowNodeEntered',
    flowNodeExit: 'OnFlowNodeExited',
    flowNodeSuspended: 'OnFlowNodeSuspended',
    flowNodeResumed: 'OnFlowNodeResumed',
    flowNodeError: 'OnFlowNodeError',
    flowNodeTerminated: 'OnFlowNodeTerminated',
    callActivityReceivedResponse: 'OnFlowNodeCallActivityResponseReceived',
    sendTaskSendMessage: 'OnFlowNodeEventSending',
    sendTaskSendMessageRetry: 'OnFlowNodeEventRetrySending',
    sendTaskReceivedResponse: 'OnFlowNodeEventResponseReceived',
    flowNodeTimerStarted: 'OnFlowNodeTimerStarted',
    flowNodeTimerRemoved: 'OnFlowNodeTimerRemoved',
    finishEmptyActivity: `/engine/emptyactivity/${messageParams.flowNodeInstanceId}/finish`,
    emptyActivityWithInstanceIdFinished: `/engine/emptyactivity/${messageParams.flowNodeInstanceId}/finished`,
    finishUserTask: `/engine/usertask/${messageParams.flowNodeInstanceId}/finish`,
    userTaskWithInstanceIdFinished: `/engine/usertask/${messageParams.flowNodeInstanceId}/finished`,
    finishManualTask: `/engine/manualtask/${messageParams.flowNodeInstanceId}/finish`,
    manualTaskWithInstanceIdFinished: `/engine/manualtask/${messageParams.flowNodeInstanceId}/finished`,
    endEventReached: `/engine/processinstance/${messageParams.processInstanceId}/ended`,
    messageEventReached: `/engine/process/message/${messageParams.messageReference}`,
    sendTaskReached: `/engine/process/sendtask/${messageParams.messageReference}`,
    receiveTaskReached: `/engine/process/receivetask/${messageParams.messageReference}`,
    signalEventReached: `/engine/process/signal/${messageParams.signalReference}`,
    processInstanceWithIdStarted: `/engine/process_started/${messageParams.processModelId}`,
    processInstanceWithIdEnded: `/engine/process/${messageParams.processInstanceId}/ended`,
    processInstanceWithIdErrored: `/engine/process/${messageParams.processInstanceId}/error`,
    terminateProcessInstanceWithId: `/engine/process/${messageParams.processInstanceId}/terminate`,
    processInstanceWithIdTerminated: `/engine/process/${messageParams.processInstanceId}/terminated`,
};
exports.EventBusSettings = {
    messageParams: messageParams,
    messagePaths: messagePaths,
};
//# sourceMappingURL=EventBusSettings.js.map